import React, { useState, ReactNode } from "react";
import { ChevronRight, ChevronDown, ChevronUp } from "lucide-react";
import { useSidebarContext } from "../context/SidebarContext";

interface MenuItemProps {
  id: string;
  icon: ReactNode;
  text: string;
  onClick: () => void;
  subTasks?: Array<{ id: string; name: string; onClick: () => void }>;
  showArrow?: boolean;
  isDropdown?: boolean;
}

const MenuItem: React.FC<MenuItemProps> = ({
  id,
  icon,
  text,
  onClick,
  subTasks,
  showArrow = false,
  isDropdown = false,
}) => {
  // const [isOpen, setIsOpen] = useState(false);
  const { openItems, toggleItem } = useSidebarContext();
  const isOpen = openItems[id];

  const handleClick = () => {
    if (isDropdown) {
      toggleItem(id);
    }
    onClick();
  };

  return (
    <div className="mb-2">
      <div
        onClick={handleClick}
        className="flex items-center justify-between px-4 py-2 text-custom-blue7 hover:bg-custom-blue0 rounded-lg cursor-pointer"
      >
        <div className="flex items-center space-x-2">
          <span className="text-custom-blue7">{icon}</span>
          <span className="lg:text-xs xl:text-sm font-medium">{text}</span>
        </div>
        {showArrow &&
          isDropdown &&
          (isOpen ? (
            <ChevronUp className="text-custom-blue7 transition-transform duration-200 xl:h-5 xl:w-5 lg:h-4 lg:w-4" />
          ) : (
            <ChevronDown className="text-custom-blue7 transition-transform duration-200 xl:h-5 xl:w-5 lg:h-4 lg:w-4" />
          ))}

        {showArrow && !isDropdown && (
          <ChevronRight width={20} height={20} className="text-custom-blue7" />
        )}
      </div>
      {/* {subTasks && subTasks.length > 0 && isOpen && (
        <div className="ml-12 mt-1 space-y-1 transition-all duration-200">
          {subTasks.map((task) => (
            <div
              key={task.id}
              onClick={(e) => {
                e.stopPropagation();
                task.onClick();
              }}
              className="xl:text-sm lg:text-xs text-custom-blue7 hover:bg-custom-blue0 py-1 px-2 rounded cursor-pointer"
            >
              {task.name}
            </div>
          ))}
        </div>
      )} */}
      {isOpen && (
        <div className="ml-12 mt-1 space-y-1 transition-all duration-200">
          {subTasks && subTasks.length > 0 ? (
            subTasks.map((task) => (
              <div
                key={task.id}
                onClick={(e) => {
                  e.stopPropagation();
                  task.onClick();
                }}
                className="xl:text-sm lg:text-xs text-custom-blue7 hover:bg-custom-blue0 py-1 px-2 rounded cursor-pointer"
              >
                {task.name}
              </div>
            ))
          ) : (
            <div className="text-custom-blue4 xl:text-sm lg:text-xs italic py-1 px-2">
              No Projects Found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MenuItem;
